const postHogAPIKey = 'phc_oresBPHLHLilIrDIPl5XBHCIEhwhf7a7Zkw7snCRCua'; //write-only
const api_host = 'https://d79la51gisl4w.cloudfront.net';
const ui_host = 'https://us.posthog.com';

const AGENT_ORGANISATION_IDS = ['c9340b46-8d41-454a-b6b4-c50fa0a3b022', '66707060-bf67-4d10-88ea-051bfd6694db', '432ad5d4-43f2-46fb-92e5-fc1cfc4a0685']; //MSL Admin, MetService Forecasters and MetraWeather
const RESELLER_ORGANISATION_IDS = ['25f0f90f-2552-4547-af00-5a981294334a']; //BOC
const OPEN_ACCESS_ORGANIZATION_ID = 'a1b37651-20fb-489d-9ac1-34965eb3e8dd';

const userInfoUrls = {
    test: 'https://wgu3xyaew5.execute-api.us-east-1.amazonaws.com/test/v0',
    acceptance: 'https://37dtzovynb.execute-api.us-east-1.amazonaws.com/acceptance/v0',
    prod: 'https://gzr9lqrg2b.execute-api.us-east-1.amazonaws.com/prod/v0',
};

export { postHogAPIKey, api_host, ui_host, AGENT_ORGANISATION_IDS, RESELLER_ORGANISATION_IDS, OPEN_ACCESS_ORGANIZATION_ID, userInfoUrls };
